import { CONAN_AIR_PLCNO_MAX, CONAN_AIR_PLCNO_MIN, PARTIAL_DISCHARGE_PLCNO } from "../Constant"

/**
 *指定したPLCNoがコナンエアー用のPLCNoかどうかを返す
 * @param plcNo　チェック対象のPLCNo
 * @returns
 */
export const IsConanAirPlc = (plcNo: string): boolean => {
  if ((CONAN_AIR_PLCNO_MIN <= Number(plcNo)) && (Number(plcNo) <= CONAN_AIR_PLCNO_MAX)) {
    return true;
  }
  return false;
}
/**
 *指定したPLCNoが部分放電のPLCNoかどうかを返す
 * @param plcNo　チェック対象のPLCNo
 * @returns
 */
export const IsPartialDischargePlc = (plcNo: string): boolean => {
  if ((PARTIAL_DISCHARGE_PLCNO == Number(plcNo))) {
    return true;
  }
  return false;
}